import type { ScreenModule } from "../../../app/screen-module";
import { PublicAgentDetailPage } from "../pages";

export default {
	id: "public.agent-detail",
	path: "/agents/:ucsId",
	area: "public",
	label: "Agent詳細",
	roles: [],
	backing: "MOCK_ONLY",
	enabled: true,
	component: PublicAgentDetailPage,
} satisfies ScreenModule;
